import { CollectionGridPage } from "@/client/components/pages/Experiments/CollectionGrid";
import { graphql } from "@/gql/index";
import { GetServerSidePropsContext } from "next/types";
import { getGraphQlClient } from "@/shared/artblocks";

const curatedProjectsListQueryDocument = graphql(`
  query CuratedProjectsListQuery @cached(ttl: 300) {
    projects_metadata(
      where: {
        vertical_name: { _eq: "curated" }
        render_complete: { _eq: true }
      }
      order_by: { index: asc }
    ) {
      ...ProjectGridData
    }
  }

  fragment ProjectGridData on projects_metadata {
    id
    name
    artist_name
    aspect_ratio
    series_id
    invocations
    contract_address
    artist_address
    slippy_map_grid_column_count
    features {
      feature_fields
      feature_fields_counts
    }
  }
`);

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const graphqlClient = getGraphQlClient();

  const res = await graphqlClient.request(curatedProjectsListQueryDocument);

  const collectionIdOrName = res.projects_metadata?.some(
    (project) =>
      project.id === context.query.collection ||
      project.name === context.query.collection
  )
    ? (context.query.collection ?? null)
    : null;

  return {
    props: {
      projects: res.projects_metadata,
      initialCollectionIdOrName: collectionIdOrName,
    },
  };
}

export default CollectionGridPage;
